import styled from 'styled-components'
import { Cross as CrossIcon } from '@aok/icon-functional'

export const QualityIndicatorIcon = styled.div`
  display: inline-block;
  border: 2px solid #6b6b6b;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 0;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }

  &.circle {
    border-radius: 50%;
  }

  &.filled {
    background-color: #6b6b6b;
  }
`

export const Cross = styled(CrossIcon)`
  margin-right: 8px;
  height: 12px;
  width: 12px;
  fill: #6b6b6b;
`
